import { atom } from "recoil"

export const AtomCurrentBadge1Url = atom({
    key:'ATOMBADGE1URl',
    default:''
})
  